import { FormData, ParcedFormData } from './types';

export const dataParcer = (value: FormData): ParcedFormData => ({
  title: value.title,
  essence: value.text,
  preferred_tutor_min_year: value.ageFrom,
  preferred_tutor_max_year: value.ageTo,
  preferred_tutor_gender: value.gender,
  preferred_tutor_time: value.time,
  preferred_tutor_types: value.mentor,
});



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/requestform/dataparcer.ts